module.exports = __webpack_public_path__ + "media/images/ukrpol_pl-c4ece57b52b70a488a0f960497ef47e3.svg";